<template>
  <FadeIn delay="200"
  class="cat-filter hide-scrollbar">
    <div class="cat-filter__inner">
      <NuxtLink 
      :to="$localePath('/blog')" 
      class="rounded-lg mr-2 sm:mr-0 mb-2 !leading-[2] sm:mb-0 bg-transparent border-[#e8e5de] border-2 px-3 py-0 text-sm md:text-base inline-block font-semibold leading-6 text-black no-underline"
      :class=" { '!bg-[#5a6ded] !border-[#3645d0] !text-white': route.fullPath === '/blog' }"
      >
        All
      </NuxtLink>
      <NuxtLink 
      v-for="(cat, index) in categories"
      :to="$localePath(`/blog/${cat.slug}`)" 
      class="rounded-lg mr-2 sm:mr-0 mb-2 !leading-[2] sm:mb-0 bg-transparent border-[#e8e5de] border-2 px-3 py-0 text-sm md:text-base inline-block font-semibold leading-6 text-black no-underline" 
      :class=" { '!bg-[#5a6ded] !border-[#3645d0] !text-white': route.params.slug == cat.slug }"
      >
        {{cat.title}}
      </NuxtLink>
    </div>
  </FadeIn>
</template>

<script setup>
const route = useRoute()
const props = defineProps({
  categories: {
    type: Object,
    required: true
  }
})
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
.cat-filter {
  padding-top: 60px;
  padding-bottom: 60px;
  width: 100%;
  overflow: scroll;
  white-space: nowrap;
  @media (min-width: $breakpoint) {
    white-space: initial;
    display: flex;
    justify-content: center;
    padding-bottom: 120px;
  }
}

.cat-filter__inner {
  gap: 0.2rem;
  display: flex;
  padding-left: 1rem;
  padding-right: 1rem;
  @media (min-width: $breakpoint-xs) {
    padding-left: 2rem;
    padding-right: 2rem;
    gap: 0.75rem;
  }
  @media (min-width: $breakpoint) {
    padding-left: 0;
    padding-left: 0;
    gap: 1rem;
    justify-content: space-between;
  }
}
</style>